
import React from 'react';
import { Button } from '../ui/button';
import { Plus, Check } from 'lucide-react';

interface RecipeActionButtonProps {
  consumed: boolean;
  onConsume: () => void;
}

const RecipeActionButton: React.FC<RecipeActionButtonProps> = ({ consumed, onConsume }) => {
  return (
    <div className="fixed bottom-16 left-0 right-0 p-4 bg-white border-t border-gray-100">
      <Button 
        onClick={onConsume}
        disabled={consumed}
        className="w-full"
        variant={consumed ? "secondary" : "default"}
      >
        {consumed ? (
          <>
            <Check className="mr-2 h-4 w-4" />
            Consumido hoy
          </>
        ) : (
          <>
            <Plus className="mr-2 h-4 w-4" />
            Registrar consumo
          </>
        )}
      </Button>
    </div>
  );
};

export default RecipeActionButton;
